import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { push } from 'connected-react-router'
import { CircleLoader } from 'components/loaders'
import { logout, removeOrganization } from 'redux/modules/auth'
import { notification, resetState } from 'redux/modules/app'
import appConfig from 'config'
import config from '../../../config'

@connect(  ({ auth }) => ({
  loginPageCode: auth.loginPageCode
}), { logout, push, notification, removeOrganization, resetState })
class Logout extends Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    removeOrganization: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    loginPageCode: PropTypes.string
  }

  static defaultProps = {
    location: {}
  }

  componentDidMount() {
    const { location, loginPageCode } = this.props

    const url = loginPageCode ? `${config.foInternalUrl}/${loginPageCode}` : config.foInternalUrl

    this.props.removeOrganization()

    this.props
      .logout()
      .then(() => {
        this.props.removeOrganization()
        this.props.resetState()

        if (url && !get(location, 'state.inactivity')) {
          try {
            window.location.replace(`${url}?isAwardStaff=true`)
          } catch (error) {
            console.log('redirect failed')
          }
        } else if (get(location, 'state.inactivity')) {
          this.props.push({
            state: { ...location.state },
            pathname: `${appConfig.publicPath}/logout-inactive`
          })
        } else {
          this.props.push({
            pathname: `${appConfig.publicPath}/login`,
            state: { ...location.state, loggedOut: true }
          })

          !get(location, 'state.disableNotification') &&
            this.props.notification("You've been logged out", {
              status: 'success',
              intlKey: 'notifications.you_have_been_logged_out'
            })
        }
      })
      .catch(() => {
        this.props.push({
          pathname: `${url || '/login'}?isAwardStaff=true`,
          state: { ...location.state, loggedOut: true }
        })
      })
  }

  render() {
    return (
      <div style={{ width: 100, margin: '10px auto' }}>
        <FormattedMessage
          id="notifications.logging_out"
          defaultMessage="Logging out..."
        />
        <CircleLoader size={60} />
      </div>
    )
  }
}

export default Logout
